import React from 'react';
import { Section } from './ui/Section';
import { FadeIn } from './ui/FadeIn';
export function LeadershipSection() {
  return <Section background="ivory" className="bg-purple-100" data-id="element-198">
      <div className="max-w-5xl mx-auto" data-id="element-199">
        <FadeIn data-id="element-200">
          <div className="text-sm uppercase tracking-widest text-charcoal/50 font-semibold mb-12 text-center" data-id="element-201">
            Leadership
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 items-center" data-id="element-202">
          <div className="md:col-span-5 flex justify-center md:justify-end" data-id="element-203">
            <FadeIn delay={200} data-id="element-204">
              <div className="w-64 h-64 md:w-80 md:h-80 rounded-full overflow-hidden border-4 border-white shadow-2xl relative" data-id="element-205">
                <img src="https://cdn.magicpatterns.com/uploads/iaRG4kZcCwyQ5NpfatJgYW/Mukisa.png" alt="Mukisa Kakembo" className="w-full h-full object-cover hover:scale-105 transition-all duration-700" data-id="element-206" />
              </div>
            </FadeIn>
          </div>

          <div className="md:col-span-7 text-center md:text-left" data-id="element-207">
            <FadeIn delay={400} data-id="element-208">
              <h3 className="text-3xl md:text-4xl font-serif text-charcoal mb-2" data-id="element-209">
                Mukisa Kakembo
              </h3>
              <div className="text-purple-700 font-medium tracking-wide mb-6 uppercase text-sm" data-id="element-210">
                Founder & CEO
              </div>
              <p className="text-lg text-charcoal/70 leading-relaxed max-w-lg mx-auto md:mx-0" data-id="element-211">
                Mukisa Kakembo leads Fem Entity with a vision to redefine how
                women experience wellness globally — merging ethical frameworks,
                technology, and community to build a new category of care.
              </p>
            </FadeIn>
          </div>
        </div>
      </div>
    </Section>;
}